<!-- 组件说明 -->
<template>
  <div class="follow-item" @click="goInfo(followItem.id)">
    <div class="index">{{ index + 1 }}</div>
    <div class="customer">{{ followItem.presentee }}</div>
    <img
      class="avator"
      :src="
        !followItem.gender
          ? require('@/common/images/recommend/sex_nan_select.png')
          : require('@/common/images/recommend/sex_nv_select.png')
      "
    />
    <div class="user">
      <span class="user-info">
        <img
          src="~/common/images/recommend/adviserName.png"
          class="user-avator"
        />
        <span class="text" style="color:#544317">
          {{ followItem.adviserName }}
        </span>
      </span>
    </div>
    <div class="remark">
      <component
        :is="remarkComponent(followItem.status)"
        :followItem="followItem"
        :noDisposeTime="noDisposeTime"
      />
    </div>
  </div>
</template>

<script>
// 引入FollowComponent下除了followitem以外的所有vue文件
// 现在看看有些新增的组件也被引入了,但没用到,但也没啥大问题
const path = require("path");
const files = require.context(
  "../FollowComponent",
  false,
  /^((?!FollowItem).)*\.vue$/
);
const modules = {};
files.keys().forEach((key) => {
  const name = path.basename(key, ".vue");
  modules[name] = files(key).default || files(key);
});
export default {
  props: {
    followItem: {
      type: Object,
    },
    index: {
      type: Number,
    },
    noDisposeTime: Number,
  },
  components: { ...modules },
  data() {
    return {};
  },
  computed: {},
  methods: {
    //   判断备注使用的组件
    remarkComponent(status) {
      let map = {
        "2": -1,
        "3": 0,
        "4": 1,
        "5": 3,
        "6": 2,
        "7": 4,
      };
      switch (map[`${status}`]) {
        // 未处理
        case -1:
          return "RemarkUntreated";
        // 未到访/已到访
        case 0:
        case 1:
          return "RemarkVisit";
        // 已签约
        case 2:
          return "RemarkSign";
        // 已认购
        case 3:
          return "RemarkDeal";
        // 已失效
        case 4:
          return "RemarkCancel";
      }
    },
    // 跳转详情
    goInfo(id) {
      this.$router.push({
        name: "oldNewDetail",
        query: { id, status: this.followItem.status },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.follow-item {
  height: 120px;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(164, 164, 164, 0.4);
  border-radius: 16px;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .index {
    width: 18px;
  }
  .customer {
    width: 86px;
  }
  .avator {
    width: 32px;
    height: 36px;
  }
  .user {
    width: 160px;
    height: 48px;

    .user-info {
      height: 48px;
      width: max-content;
      display: flex;
      align-items: center;
      background: #f9f4e8;
      border-radius: 0px 12px 12px 12px;
      padding: 4px 16px;
      .user-avator {
        width: 26px;
        height: 24px;
        margin-right: 8px;
      }
      .text {
        display: inline-block;
        max-width: 110px;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
  .remark {
    width: 280px;
  }
}
</style>
